import listActions from 'src/modules/historialInventario/list/historialInventarioListActions';
import HistorialInventarioService from 'src/modules/historialInventario/historialInventarioService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'HISTORIALINVENTARIO_DESTROY';

const historialInventarioDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: historialInventarioDestroyActions.DESTROY_STARTED,
      });

      await HistorialInventarioService.destroyAll([id]);

      dispatch({
        type: historialInventarioDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.historialInventario.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/historial-inventario');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: historialInventarioDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: historialInventarioDestroyActions.DESTROY_ALL_STARTED,
      });

      await HistorialInventarioService.destroyAll(ids);

      dispatch({
        type: historialInventarioDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.historialInventario.destroyAll.success'),
      );

      getHistory().push('/historial-inventario');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: historialInventarioDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default historialInventarioDestroyActions;
